import { render } from "./PartnerCleo.vue?vue&type=template&id=ca29b9ce"
import script from "./PartnerCleo.vue?vue&type=script&lang=js"
export * from "./PartnerCleo.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__